import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { PortalConfigSelector } from '../../../store/config/selectors';

import { ReactComponent as CreateChatIcon } from '../../../assets/images/createChat.icon.svg';
import Button from '../../../components/Button/Button';
import { tt } from '@i18n/tt';

import useStyles from '../styles';

interface IProps {
  setOpenCreateChatDialog: (value: boolean) => void;
}

const CreateChatArea: FC<IProps> = ({ setOpenCreateChatDialog }) => {
  const classes = useStyles();
  const config = useSelector(PortalConfigSelector);

  if (config.disableChats) return null;

  return (
    <div className={classes.homePageTile}>
      <div>
        <CreateChatIcon />
      </div>

      <div>
        <h1>{tt('pages.homeOld.chartCard.title')}</h1>
        <p>
          {tt('pages.homeOld.chartCard.description')}
        </p>
        <Button
          text={tt('pages.homeOld.chartCard.button')}
          onClick={() => {
            setOpenCreateChatDialog(true);
          }}
        />
      </div>
    </div>
  );
};

export default CreateChatArea;
